import { Component, OnInit, Inject } from '@angular/core';
import { Subsidiary } from '@app/base/core/models';
import { SessionService, LookupsService, ConstantsService, EnvironmentService, AccountService } from '@app/core/services';
import { BuilderService } from '../../base';
import { SocoHttpService } from '@app/soco/http';
import { takeWhile } from 'rxjs/operators';
import { AlertService } from '@app/base/alerts/alert.service';
import { NavigationEnd, Router } from '@angular/router';

declare var swal: any;
require('sweetalert');

interface SubName {
  id: number;
  itemName: string;
}
@Component({
  selector: 'app-subsidiary',
  templateUrl: './subsidiary.component.html',
  styleUrls: ['./subsidiary.component.css']
})
export class SubsidiaryComponent implements OnInit {
  // Searching
  queryString: any;
  // pagination
  p = 1;
  subsidiaryList: Subsidiary[] = [];
  subsidiaryName: string[] = [];
  obj: Subsidiary;
  subList: string[];
  subsidiaryId: string[];
  public builderdata: any = {};
  state: string;
  streetname: string;
  builderMapping = [];
  city: string;
  userName: string;
  killsubscribe: boolean;
  cityValues = [];
  stateValues = [];
  alertMsg: any = [];
  updateFlag;
  projectNumber: any;

  // constructor
  constructor(
    private session: SessionService,
    @Inject(Router) private router: Router,
    private builderSvc: BuilderService,
    private lookupSvc: LookupsService,
    public accountSvc: AccountService,
    private socoHttp: SocoHttpService, private alertService: AlertService,
    public environmentSvc: EnvironmentService,
    public constantsService: ConstantsService) {

  }

  // used to initialise services
  ngOnInit() {
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      if (val) {
         this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Subsidiary'
       ));
        this.alertService.info(this.alertMsg.message);
        this.cityValues = this.lookupSvc.cities;
        this.stateValues = this.lookupSvc.states;
      }
    });
    this.killsubscribe = true;
    this.session.builderData.subscribe(result => {
      if (result) {
        this.subsidiaryId = result.subsidiaryId;
        this.builderdata.builderId = result.BuilderId[0];
        this.builderdata.companyName = result.CompanyName;
        this.builderdata.subsidiaryId = result.subsidiaryId;
        this.builderdata.builderMapping = result.BuilderMapping;
        this.subsidiaryDetailsInfo();

      } else {
        const subsidiaryId = [];
        this.builderSvc.getBuilderInfo(this.accountSvc.account.user.company).subscribe(
          result => {
            if (result.data !== undefined && result.data.length !== 0) {
              this.builderdata.builderId = result.data.id;
              this.builderdata.companyName = result.data.companyName;
                for (let i = 0; i < result.data.builderMapping.length; i++) {
                    subsidiaryId.push(result.data.builderMapping[i].subsidiaryId);
                }
                this.builderdata.builderMapping = result.data.builderMapping;
                this.subsidiaryId = subsidiaryId;
                this.subsidiaryDetailsInfo();
    }
  });
}

    });
    $('#modal_add_subsidiary').on('shown.bs.modal', function(event) {
      // not setting focus to submit button
      $('#btnClose').focus();
    });
    this.userName = this.accountSvc.account.user.username;
  }

  subsidiaryStatus(val) {
    if (this.builderMapping.length === 0) {
for (let i = 0; i < this.builderdata.builderMapping.length; i++ ) {
  if (this.builderdata.builderMapping[i].subsidiaryId === val) {
    return {
      status: this.builderdata.builderMapping[i].status,
      comments: this.builderdata.builderMapping[i].comments
  };
}
  }
} else {
  for (let i = 0; i < this.builderMapping.length; i++ ) {
    if (this.builderMapping[i].subsidiaryId === val) {
      return {
        status: this.builderMapping[i].status,
        comments: this.builderMapping[i].comments
    };
  }
}
}
this.builderMapping = [];
}
  // code to fetch subsidiary details from DB
  subsidiaryData() {
    if (this.subsidiaryId.length !== 0) {      
    this.builderSvc.getSubsidiaryInfo(this.subsidiaryId).subscribe(result => {
      if (result.data !== null || result !== undefined) {
        for (let i = 0; i < result.data.length; i++) {
          this.obj = new Subsidiary;
          this.obj.EmailId = result.data[i].email;
          this.obj.SubsidiaryCompanyName = result.data[i].companyName;
          if (result.data[i].builderAddresses.contactName1Phone !== null) {
            this.obj.Number = result.data[i].builderAddresses.contactName1Phone
              .replace(/-/g, '').replace(/^([0-9]{3})([0-9]{3})([0-9]{4})$/, '$1-$2-$3');
          }
          if (result.data[i].builderAddresses.city !== null && this.cityValues.length>0) {
            this.city = this.cityValues.find(x => String(x.id) === result.data[i].builderAddresses.city).itemName;
          }           
          if (result.data[i].builderAddresses.state !== null && this.stateValues.length>0) {
            this.state = this.stateValues.find(x => String(x.id) === result.data[i].builderAddresses.state).itemName;
          }
          if ( result.data[i].builderAddresses.streetNumber !== null && result.data[i].builderAddresses.streetName !== null) {
          this.obj.AddressLine1 = result.data[i].builderAddresses.streetNumber + ', ' + result.data[i].builderAddresses.streetName + ', '
            + this.city;
          } else if (result.data[i].builderAddresses.streetName !== null) {
            this.obj.AddressLine1 = result.data[i].builderAddresses.streetName + ', '
            + this.city;
          } else {
            this.obj.AddressLine1 = this.city;
          }

          this.obj.AddressLine2 = this.state + '-' + result.data[i].builderAddresses.zipCode;

          this.obj.status = this.subsidiaryStatus(result.data[i].id) ? this.subsidiaryStatus(result.data[i].id).status : null;
          this.obj.comments = this.subsidiaryStatus(result.data[i].id) ? this.subsidiaryStatus(result.data[i].id).comments : null;

          if (!this.subsidiaryName.find(x => x === this.obj.SubsidiaryCompanyName)) {
            this.subsidiaryName.push(this.obj.SubsidiaryCompanyName);
            this.subsidiaryList.push(this.obj);

          }
        }
this.builderSvc.subsidiaryId.subsidiaryId = null;
        this.socoHttp.hidePleaseWait('ContainerAwaiter');
      } else {

        this.socoHttp.hidePleaseWait('ContainerAwaiter');
      }
    },
    (error) => {
      swal(this.constantsService.errorSwal1, this.constantsService.subsidiaryDetailsFailSwal, this.constantsService.errorSwal);
      this.socoHttp.hidePleaseWait('ContainerAwaiter');
    });
  } else {
    this.socoHttp.hidePleaseWait('ContainerAwaiter');
  }
  }

  subsidiaryDetailsInfo() {
 // code to populate previously loaded subsidiary data from service if user is visiting subsidiary tab again
 this.session.subsidiaryDetails.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
  if (success !== null) {
    for (let i = 0; i < success.length; i++) {
      this.obj = new Subsidiary;
      this.obj.SubsidiaryCompanyName = success[i].SubsidiaryCompanyName;
      this.obj.EmailId = success[i].EmailId;
      this.obj.Number = success[i].Number;
      this.obj.status = success[i].status;
      this.obj.comments = success[i].comments;
      this.obj.AddressLine1 = success[i].AddressLine1;
      this.obj.AddressLine2 = success[i].AddressLine2;
      this.subsidiaryList.push(this.obj);
    }
  } else {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
    this.subsidiaryData();
  }
});
  }

  // code to pass subsidiary data fetched from DB to service
  passSubsidiaryDetails() {
    this.session.GetSubsidiary(this.subsidiaryList);
  }

    // To go to builder home page
    navigateHome() {
      this.session.GetBcaData(null);
      this.router.navigate([
        this.session.paramLdc.toLowerCase(),
        'builder',
        'home'
        ]);
    }
  // used to unsubscribe to services
  ngOnDestroy() {
    if ($('#modal_add_subsidiary').is(':visible')) {
      $('#modal_add_subsidiary').modal('hide');
    }
    this.killsubscribe = false;
    this.passSubsidiaryDetails();
  }
  routeFlag() {
    this.router.navigate([
      this.session.paramLdc.toLowerCase(),
      'builder',
      'add-subsidiary'
    ]);
  }
  updateSubsidiaryDetails(eve: any) {
    this.updateFlag = true;
    if (this.builderSvc.subsidiaryId.subsidiaryId !== null) {
    this.subsidiaryId = [];
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
    this.builderSvc.getBuilderInfo(this.accountSvc.account.user.company).subscribe(
      result => {
        if (result.data.length !== 0) {
            for (let i = 0; i < result.data.builderMapping.length; i++) {
             this.subsidiaryId.push(result.data.builderMapping[i].subsidiaryId);
            }

          this.builderMapping = result.data.builderMapping;
          this.subsidiaryData();
        }
        });
      }
  }
}


